import { Component, Renderer, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, ParamMap } from '@angular/router';
import { CreateDialogStateService } from './create-dialog-communications/create.dialog.communications.state.service';
import { CommunicationsStateService } from './communications.state.service';
import { CommunicationsHttpService } from '../../../services/communications/communications.http.service';
import { CommunicationsHttpUtil } from './communications.util';
import { StorageUtil } from '../../../utils/storage.util';
import { count } from 'rxjs/operator/count';

@Component({
  moduleId: module.id,
  templateUrl: 'communications.component.html',
  providers: []
})

export class CommunicationsComponent implements OnInit, OnDestroy {

  model: any = {};
  errorMessage: string;
  chatExist: boolean = true;
  searchText: String = '';

  readonly TAB_OPEN = 'open';
  readonly TAB_CLOSE = 'close';
  activeTab = this.TAB_OPEN;

  newQuest = {};
  chatOpenedDialogStatus: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private createDialogStateService: CreateDialogStateService,
    private communicationsStateService: CommunicationsStateService,
    private communicationsHttpService: CommunicationsHttpService,
    private renderer: Renderer
  ) {
    this.renderer.setElementClass((<any>document.getElementById('wrapper')), 'messages', true);
  }

  ngOnInit() {
    // TODO: revert when make request to all chats
    // let data = this.route.snapshot.data['data'];
    // if(data.json().response) {
    //   let model = data.json().response;
    //   if(model.items.length) {
    //     this.chatExist = true;
    //   }
    // } else if(data.json().error) {
    // }

    const requestParams = CommunicationsHttpUtil.prepareParamsGetChats({
      securityToken: StorageUtil.getToken()
    });

    this.communicationsHttpService.getCountChats(requestParams).subscribe(success => {
      const data = success.json();
      // TODO: clean when make request to all chats
      this.chatExist = !!(data.response['activeChat'] + data.response['closedChat']);
    });

    this.communicationsStateService.handleNewQuest().subscribe(data => {
      if (this.activeTab === this.TAB_CLOSE) {
        this.activeTab = this.TAB_OPEN;
      }
      // TODO: revert after get chatId after create chat;
      // this.newQuest = {
      //   number: data.number,
      //   theme: data.theme,
      //   chatType: data.chatType,
      // };
      // this.chatExist = true;

    });

    // For add mobile class and hide chat list and show dialog
    this.communicationsStateService.handleSetMobileClass().subscribe(data => {
      this.setMobileClass(data.dialogStatus);
    });
  }

  triggerResetQuest($event) {
    this.newQuest = {};
  }

  filterChatList(value): any {
    this.searchText = value;
  }

  openCreateDialog($event) {
    $event.preventDefault();
    this.createDialogStateService.triggerDialogStatus({display: true});
  }

  setMobileClass(flag) {
    this.chatOpenedDialogStatus = flag;
  }

  ngOnDestroy() {
    this.renderer.setElementClass((<any>document.getElementById('wrapper')), 'messages', false);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/communications/communications.component.ts